<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="Object.values(nodes)"
      hide-actions
      disable-initial-sort
    >
      <template v-slot:items="props">
        <td>
          <a :href="`https://ipfs.io/ipns/${props.item.id}`" target="_blank">{{props.item.id}}</a>
        </td>
        <td>
          <Link
            v-if="props.item.address"
            type="address"
            :to="props.item.address"
            :text="props.item.address"
          />
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="props.item.lighthouse">{{props.item.lighthouse}}</span>
          <span v-else>-</span>
        </td>
        <td>
          <v-icon v-if="props.item.provider">check_circle_outline</v-icon>
          <v-icon v-else>not_interested</v-icon>
        </td>
        <td>
          <span v-if="props.item.peers">{{props.item.peers.length}}</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="props.item.date">{{props.item.date}}</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="props.item.network">{{props.item.network}}</span>
          <span v-else>-</span>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "ipns", value: "id" },
        { text: "address eth", value: "address" },
        { text: "lighthouse", value: "lighthouse" },
        { text: "provider", value: "provider" },
        { text: "peers", value: "peers" },
        { text: "date", value: "date" },
        { text: "network", value: "network" }
      ]
    };
  },
  computed: mapState({
    nodes: state => state.net.nodes
  })
};
</script>
